// Centralized data/API paths for the app

export const DATA_PATHS = {
    // Map layer files - Direct file access for gzipped GeoJSON layers
    // Functions accept areaSlug for PER_AREA strategy
    MAP_LAYERS: {
        BACKGROUND: (areaSlug) => areaSlug ? `/data/${areaSlug}/background.geojson.gz` : '/data/background.geojson.gz',
        BORDERS: (areaSlug) => areaSlug ? `/data/${areaSlug}/borders.geojson.gz` : '/data/borders.geojson.gz',
        ROADS: (areaSlug) => areaSlug ? `/data/${areaSlug}/roads.geojson.gz` : '/data/roads.geojson.gz'
    },

    // Legacy single file paths (kept for backward compatibility)
    TOPOJSON_FILE: '/data/map.json',  // Direct file path
    GEOJSON_FILE: '/data/map.geojson', // Direct file path

    // API fallback paths (kept for compatibility)
    TOPOJSON_FILE_API: '/app_core/api/sqlite/get-json.php?file=map.json',
    GEOJSON_FILE_API: '/app_core/api/sqlite/get-json.php?file=map.geojson',

    // Database endpoints - Step-based API
    CITIES_LIST: '/app_core/api/sqlite/spots-area-selector.php',

    // Search flow endpoints
    SEARCH_CITIES: '/app_core/api/sqlite/spots-area-selector.php',
    SEARCH_TAGS: '/app_core/api/sqlite/spots-search-2-tags.php',
    SEARCH_RESULTS: '/app_core/api/sqlite/spots-search-3-results.php',

    // Discover flow endpoints
    EXPLORE_AREAS: '/app_core/api/sqlite/spots-area-selector.php',
    EXPLORE_PACKS: '/app_core/api/sqlite/spots-explore-2-packs.php',
    EXPLORE_TAGS: '/app_core/api/sqlite/spots-explore-3-tags.php',
    // Deprecated: client-side filtering is canonical. Do not call this on tag selection.
    EXPLORE_RESULTS: '',

    DISCOVER_MAPS: '/app_core/api/sqlite/get-maps.php',

    // Canonical spot data endpoint
    SPOTS_IDS: '/app_core/api/sqlite/spots-ids.php',

    // Legacy endpoint (kept for backward compatibility)
    SPOTS: (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return `/app_core/api/sqlite/spots-search-3-results.php?${queryString}`;
    },

    // Use database by default
    USE_DATABASE: true
}; 
